// extracted by mini-css-extract-plugin
export default {"wrapper":"DashboardLayout_wrapper__8FF6T"};